export default {
  metaDescription: 'Jelajahi peluang karir di PT Tokki Engineering and Fabrication (TEF) dan bergabunglah dengan tim yang terus berkembang di bidang fabrikasi dan teknik industri.',
  pageTitle: 'Karir',
  noOpenings: 'Saat ini belum ada lowongan pekerjaan yang tersedia. Nantikan informasi selanjutnya!',
  byAdmin: 'Oleh Admin',
  readMore: 'BACA SELENGKAPNYA',
  modal: {
    department: 'Departemen',
    location: 'Lokasi',
    level: 'Level',
    jobSummary: 'Ringkasan Pekerjaan',
    responsibilities: 'Tanggung Jawab',
    requirements: 'Persyaratan',
    apply: 'Lamar Sekarang',
  },
};
